<h1 class="page-title">Istentiszteletek</h1>

<!--<img alt="Kép egyik istentiszteletünkről" />-->
<p>
  Azt gondoljuk, minden keresztény ember számára fontos, hogy hitét ne csak magában élje meg, hanem tartozzon egy
  közösséghez, és ott renszeresen, legalább hetente egyszer, kapjon "lelki táplálékot" is.
</p>

<p>
  Tanítóink törekednek arra, hogy amiről beszélnek, az ne valami elvont dolog legyen, hanem kézzel fogható, használható,
  és működő tanácsok legyenek az élet különböző területeire. Ilyen témák például a megbocsátás, kapcsolatok, szeretet,
  elfogadás, kegyelem, győzelem a körülmények és nehézségek felett.
</p>

<h2>Helyszín, időpont</h2>

<p>
  Alkalmainkat a KKK Közösségi Házban tartjuk minden vasárnap, 16 órai kezdettel.
  KKK Közösségi Ház: 7400, Kaposvár, Kanizsai u. 56. [Roberto csempe áruház mellett]
  <a [routerLink]="['/kapcsolat']">Kapcsolat</a>
</p>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/what-we-do/services/services.component.html